import React, { useState } from 'react';
import EmojiPicker from './EmojiPicker';

const CommentForm = ({ currentUser, onSubmitComment }) => {
  const [commentText, setCommentText] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!commentText.trim()) return;
    
    onSubmitComment(commentText);
    setCommentText('');
  };
  
  const handleEmojiSelect = (emoji) => {
    setCommentText(prev => prev + emoji);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="relative flex items-start gap-3"
    >
      {currentUser.profile_image ? (
        <img
          src={currentUser.profile_image}
          alt="user"
          className="w-8 h-8 rounded-full object-cover"
        />
      ) : (
        <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
          {currentUser.name?.charAt(0).toUpperCase() || 'U'}
        </div>
      )}
      
      <div className="flex-1 relative">
        <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
          <input
            type="text"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            placeholder="Add a comment..."
            className="flex-1 outline-none bg-transparent"
          />
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Add emoji"
            >
              😊
            </button>
            {commentText.trim() && (
              <button
                type="submit"
                className="text-blue-600 font-medium"
              >
                Post
              </button>
            )}
          </div>
        </div>
        
        {showEmojiPicker && (
          <EmojiPicker
            onEmojiSelect={handleEmojiSelect}
            onClose={() => setShowEmojiPicker(false)}
            position="bottom"
          />
        )}
      </div>
    </form>
  );
};

export default CommentForm;